module.exports = __webpack_public_path__ + "img/1.a424bd2c.png";